import { merge } from 'Shared/common/merge';

export function standardPoster(palette,fonts)
{
	return ({
		options: {
			overlapping: 'Standard',
			separated: 'Separated'
		},
		/* NOTE the ThemeProvider merges the custom type into the shared type */
		shared: {
			root: {
				color: palette.text,
				fontFamily: fonts.text,
				lineHeight: 1.2,
				width: 264,
				height: 'calc(264px * 1.414)',
				textAlign: 'center',
				fontSize: 16
			},
			dateBar: { },
			name: {
				fontSize: 16,
				textTransform: 'uppercase',

			},

			tagline: {	
				fontSize: 16,
			},
			artistNames: {
				fontSize: 16
			},

//TODO nest in 'type:' or something... or raise these up a level? Remove 'Poster'
			photoPoster: {
				squareName: {},
				squareTagline: {},
				overlayedName: {},
				overlayedTagline: {},
			},

			oneAct: {
				artistNames: {
					fontSize: 19
				},
			},
			fiveActs: {
				name: {
					fontSize: 13
				},
			},
			overlayedPoster: {
				name: {
					fontSize: 21 
				},
			},
			squareImagePoster: {
				name: {	
					fontSize: 14,
				},
			},
			inlinePoster: {
				name: {	
					fontSize: 14
				},
				tagline: {
					fontSize: 14
				}
			},
			imagelessPoster: {
				name: {
					fontSize: 42
				},
			}
		},
		themes: {   
			//XXX I'm thinking that any bits that are common between 'overlapping' and 'separated' are 
			//    best put into utility functions, rather than in a 'base' field.
			overlapping: {
				dateBar: { },

				contents:{
					padding: '8px 8px 0 8px',
					textAlign: 'center',
					//lineHeight: 1.2,
				},
				imageWrap: {},
				tagline:{
					fontStyle: 'italic',
				},
				genres:{},
				fourActs: {
					name: {
						fontSize: 13
					},
				}
			},
			separated: {
				twoActs: {
					artistNames: {
						fontSize: 13
					},
				},
				threeActs: {
					artistNames: {
						fontSize: 13
					},
				},
				fourActs: {
					artistNames: {
						fontSize: 11
					},
				},
			},
		}
	});
}

export function posterSettingsName(event)
{
	if (event.imageType == 'photo') {
		if (event.imageDimensions == 'portrait4x5' || event.imageDimensions == 'portrait') 
			return 'overlayedPoster';
		else if (event.imageDimensions == 'landscape')
			return 'inlinePoster';
		else if (event.imageDimensions == 'square')
			return 'squareImagePoster';
	}

	if (event.imageType == 'poster')
		return 'suppliedPoster';

	/* event.imageType == 'auto' */ 

	if (event.eventType != 'music') 
		return 'imagelessPoster';

	if (event.eventType == 'music') {
		const numActs = event.lineup?.length ?? 0;

		switch (numActs) {
			case 1: return 'oneAct';
			case 2: return 'twoActs';
			case 3: return 'threeActs';
			case 4: return 'fourActs';
			default: return 'fiveActs';
		}
	}
}

export function posterSettings(siteTheme,posterThemeName:string,posterType:string)
{
//XXX Q: do we really want to access this via 'page'?	
	const p = siteTheme.page.poster;

	let ret = merge(p.shared, p.themes[posterThemeName] ?? p.themes.overlapping);

	/* Merge in 'oneAct' etc */
	if (posterType) 
		ret = merge(ret,ret[posterType] ?? {});

	return ret;
}

